<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-novo-papel')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-papel')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="20%"
      >
        <el-form-item :label="$t('codigo')" prop="code">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-input
              ref="code"
              :disabled="id !== ''"
              v-model="ruleForm.code"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('usuarios')" prop="user">
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-switch ref="user" v-model="ruleForm.user"></el-switch>
          </el-col>
          <el-col
            class="line text-right"
            style="padding-right: 12px"
            :xs="24"
            :sm="3"
            :md="3"
            :lg="2"
            :xl="2"
            >{{ $t("cliente") }}</el-col
          >
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-switch ref="customer" v-model="ruleForm.customer"></el-switch>
          </el-col>
          <el-col
            class="line text-right"
            style="padding-right: 12px"
            :xs="24"
            :sm="3"
            :md="3"
            :lg="2"
            :xl="2"
            >{{ $t("parceiro") }}</el-col
          >
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-switch ref="partner" v-model="ruleForm.partner"></el-switch>
          </el-col>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="grid-content">
              <span
                >{{ $t("menu-cadastros") }}
                <el-switch
                  v-model="all.register"
                  @change="update('register', ruleForm.menu.register)"
                  :active-text="$t('todos')"
                ></el-switch>
              </span>
              <el-divider></el-divider>
              <el-switch
                :active-text="$t('agendamento-tarefas')"
                v-model="ruleForm.menu.register.tasks"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('atendimento')"
                v-model="ruleForm.menu.register.attendance"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('ausencia-programada')"
                v-model="ruleForm.menu.register.scheduledabsence"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('banco')"
                v-model="ruleForm.menu.register.bank"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('cliente')"
                v-model="ruleForm.menu.register.customer"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('contrato')"
                v-model="ruleForm.menu.register.contract"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('departamento')"
                v-model="ruleForm.menu.register.department"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('destinatario')"
                v-model="ruleForm.menu.register.delivery"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('embalagem')"
                v-model="ruleForm.menu.register.packing"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('entregador')"
                v-model="ruleForm.menu.register.couriers"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('equipe')"
                v-model="ruleForm.menu.register.team"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('filial')"
                v-model="ruleForm.menu.register.branch"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('grupo-servico')"
                v-model="ruleForm.menu.register.servicegroup"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('integracao')"
                v-model="ruleForm.menu.register.integration"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('itens')"
                v-model="ruleForm.menu.register.items"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('motivo')"
                v-model="ruleForm.menu.register.reason"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('remetente')"
                v-model="ruleForm.menu.register.sender"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('rota')"
                v-model="ruleForm.menu.register.route"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('papel')"
                v-model="ruleForm.menu.register.role"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('parametros')"
                v-model="ruleForm.menu.register.parameter"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('servicos')"
                v-model="ruleForm.menu.register.services"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('tabela-pacote')"
                v-model="ruleForm.menu.register.packagetable"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('tabela-preco')"
                v-model="ruleForm.menu.register.pricetable"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('unidade')"
                v-model="ruleForm.menu.register.unit"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('usuarios')"
                v-model="ruleForm.menu.register.user"
              ></el-switch>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">
              <span
                >{{ $t("menu-servicos") }}
                <el-switch
                  v-model="all.services"
                  @change="update('services', ruleForm.menu.services)"
                  :active-text="$t('todos')"
                ></el-switch>
              </span>
              <el-divider></el-divider>
              <el-switch
                :active-text="$t('prepostagem')"
                v-model="ruleForm.menu.services.prepost"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('postagem')"
                v-model="ruleForm.menu.services.post"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('importar')"
                v-model="ruleForm.menu.services.import"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('exportar')"
                v-model="ruleForm.menu.services.export"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('auditoria')"
                v-model="ruleForm.menu.services.audit"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('ordemservico')"
                v-model="ruleForm.menu.services.orderservices"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('etiquetas')"
                v-model="ruleForm.menu.services.tag"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('logistica-reversa')"
                v-model="ruleForm.menu.services.reverse"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('carga-objetos')"
                v-model="ruleForm.menu.services.loadobjects"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('conferencia-objetos')"
                v-model="ruleForm.menu.services.loadobjectscheck"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('cockpit-prepostagem-usuario')"
                v-model="ruleForm.menu.services.cockpittuser"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('cockpit-prepostagem-admin')"
                v-model="ruleForm.menu.services.cockpitadmin"
              ></el-switch>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">
              <span
                >{{ $t("menu-consultas") }}
                <el-switch
                  v-model="all.search"
                  @change="update('search', ruleForm.menu.search)"
                  :active-text="$t('todos')"
                ></el-switch>
              </span>
              <el-divider></el-divider>
              <el-switch
                :active-text="$t('objetos-sro')"
                v-model="ruleForm.menu.search.objectssro"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('encontre-cep')"
                v-model="ruleForm.menu.search.cep"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('log-sistema')"
                v-model="ruleForm.menu.search.systemlog"
              ></el-switch>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">
              <span
                >{{ $t("menu-financeiro") }}
                <el-switch
                  v-model="all.financial"
                  @change="update('financial', ruleForm.menu.financial)"
                  :active-text="$t('todos')"
                ></el-switch>
              </span>
              <el-divider></el-divider>
              <el-switch
                :active-text="$t('tipo')"
                v-model="ruleForm.menu.financial.type"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('cockpit-financeiro-admin')"
                v-model="ruleForm.menu.financial.cockpitadmin"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('cockpit-financeiro-usuario')"
                v-model="ruleForm.menu.financial.cockpituser"
              ></el-switch>
              <br />
              <el-switch
                :active-text="$t('cockpit-financeiro-dashboard')"
                v-model="ruleForm.menu.financial.cockpitdashboard"
              ></el-switch>

              <br />
            </div>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button
            type="warning"
            v-if="id === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="id !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { RoleService } from "@/services/role/role.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "RoleAdd",
  data() {
    return {
      id: "",
      all: {
        register: false,
        services: false,
        search: false,
        financial: false,
      },
      ruleForm: {
        name: "",
        code: "",
        user: true,
        customer: true,
        partner: true,
        menu: {
          register: {
            user: false,
            customer: false,
            sender: false,
            role: false,
            department: false,
            parameter: false,
            services: false,
            packing: false,
            servicegroup: false,
            pricetable: false,
            tasks: false,
            contract: false,
            branch: false,
            team: false,
            couriers: false,
            bank: false,
            route: false,
            items: false,
            driver: false,
            attendance: false,
            callcenter: false,
            delivery: false,
            unit: false,
            integration: false,
            reason: false,
            scheduledabsence: false,
            packagetable: false,
          },
          services: {
            prepost: false,
            post: false,
            import: false,
            orderservices: false,
            tag: false,
            reverse: false,
            prepostmanager: false,
            loadobjects: false,
            loadobjectscheck: false,
            cockpitadmin: false,
            cockpittuser: false,
            audit: false,
          },
          search: {
            objectssro: false,
            cep: false,
            systemlog: false,
          },
          financial: {
            type: false,
            cockpitadmin: false,
            cockpituser: false,
            cockpitdashboard: false,
          },
        },
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: i18n.tc("codigo-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({
        name: "role",
      });
    },
    update(property, o) {
      const vm = this;
      for (const key in o) {
        o[key] = vm.all[property];
      }
    },
    get() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      RoleService.get(vm.id)
        .then((response) => {
          vm.ruleForm.name = response.name;
          vm.ruleForm.code = response.code;
          vm.ruleForm.user = response.user;
          vm.ruleForm.customer = response.customer;
          vm.ruleForm.partner = response.partner;
          for (const row of response.menu) {
            const t = row.menu.split(".");
            vm.ruleForm.menu[t[0]][t[1]] = true;
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          RoleService.add(
            vm.ruleForm.code,
            vm.ruleForm.name,
            vm.ruleForm.user,
            vm.ruleForm.customer,
            vm.ruleForm.partner,
            vm.ruleForm.menu
          )
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("papel-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          RoleService.update(
            vm.id,
            vm.ruleForm.name,
            vm.ruleForm.user,
            vm.ruleForm.customer,
            vm.ruleForm.partner,
            vm.ruleForm.menu
          )
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("papel-atualizado-sucesso"),
              });
              vm.$router.replace({
                name: "role",
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.code.$el.children[0].focus();
    }
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
